/**
 * User Permissions Configuration
 *
 * This file contains all permission-related constants and configurations
 * used throughout the application for user management.
 */

export const PERMISSIONS_LIST = [
  "manage_rooms",
  "send_message",
  "edit_message",
  "delete_message",
  "voice_call",
  // "video_call", // left as an option for a client, please don't remove
  "camera_access",
  "voice_message",
  "location_share",
  // "attachment_send", // handled by BE
  "attachment_forward",
  "file_access",
  // "gallery_access",
  "invite_guests",
  // "add_guest_to_room",
  "search_users",
  "block_users",
  "emergency_message",
];
